module.exports = "<p>\n  call-to-action-item works!\n</p>\n"